import React from "react";
import styles from "./message-oracular.module.css";
import { useSelector } from "react-redux";


const MessageOracular = (props) => {
  const oracular = useSelector((store) => store.tarotChat.oracular);
  return (
    <div className={styles.container}>
      <img className={styles.expert_image} src={oracular.avatar} alt="expert"/>
      <div className={styles.message}>
        {props.children}
      </div>
      {/* <ChatInput/> */}
    </div>
  );
};

export { MessageOracular };
